import { dataHooks } from '@wix/data-hooks';

export const footerDataHooks = dataHooks<{
  description: {};
  linkLabel: {};
  link: {};
}>('new-footer');
